import { ColorSchemeController, type ColorSchemePreference } from "@codeshare/theme";
import { useSyncExternalStore } from "react";

// One controller for the app's lifetime; it owns <html data-theme>.
const controller = new ColorSchemeController();

const subscribe = (listener: () => void) => controller.subscribe(listener);
const getPreference = () => controller.preference;
const getScheme = () => controller.scheme;

export function useColorScheme() {
  const preference = useSyncExternalStore(subscribe, getPreference);
  const scheme = useSyncExternalStore(subscribe, getScheme);
  return {
    preference,
    scheme,
    setPreference: (next: ColorSchemePreference) => controller.setPreference(next),
  };
}
